import videoMaterials from '@/assets/video';
import { Box, Image } from '@chakra-ui/react';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';

type Props = {
  url?: string;
  width?: string;
  height?: string;
  controls?: boolean;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  poster?: string;
};

const VideoPlayer = ({
  url = videoMaterials.manMeditating,
  poster = videoMaterials.manMeditatingPoster,
  controls = false,
  width = '100%',
  height = '100%',
  loop = true,
  muted = true,
  autoPlay = true,
}: Props) => {
  const [isPlaying] = React.useState(autoPlay);
  const [isVideoReady, setIsVideoReady] = useState(false);

  const handleOnReady = () => {
    setIsVideoReady(true);
  };

  return (
    <Box
      position={'absolute'}
      inset={0}
      width={width}
      height={height}
      overflow={'hidden'}
      zIndex={-1}
      sx={{
        video: {
          objectFit: 'cover',
        },
      }}
    >
      {!isVideoReady && (
        <Image
          src={poster}
          alt="video-poster"
          position={'absolute'}
          inset={0}
          width={'100%'}
          height={'100%'}
          objectFit={'cover'}
        />
      )}
      <Box width={'100%'} height={'100%'}>
        <ReactPlayer
          url={url}
          controls={controls}
          muted={muted}
          pip
          width={width}
          height={height}
          loop={loop}
          playing={isPlaying}
          onReady={handleOnReady}
          config={{
            file: {
              attributes: {
                preload: 'auto',
              },
            },
          }}
          style={{ height, width, position: 'absolute', inset: 0 }}
        />
      </Box>
    </Box>
  );
};

export default VideoPlayer;
